"use client";
import { useState } from "react";
import { getChartById } from "@/services/apis/modules/indicators";

export const useGetLatestChartData = () => {
  const [chartData, setChartData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchChartData = async ({
    id,
    range_time,
    type,
  }: {
    id?: string;
    range_time: string;
    type?: string;
  }) => {
    setLoading(true);
    try {
      const response = await getChartById({
        ...(id && { id }),
        ...(range_time ? { range_time } : {}),
        ...(type && { type }),
      });
      setChartData(response);
      return response;
    } catch (error) {
      console.error("Error fetching chart data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleGetChartData = async (id?: string, type?: string) => {
    return await fetchChartData({ ...(id && { id }), range_time: "12", ...(type && { type }) });
  };

  const handleGetChartDataByRange = async (item: any) => {
    return await fetchChartData({
      id: item?.id,
      range_time: item?.range_time,
      type: item?.type,
    });
  };

  return { chartData, loading, handleGetChartData, handleGetChartDataByRange };
};
